import { ChangeDetectorRef, Component, ElementRef, EventEmitter, NgZone, OnInit, Output, Self, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { cons } from '@hyperjump/json-schema/instance/experimental';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { columnsDef } from 'src/app/interfaces/columnsDef';
import { FormServices } from 'src/app/services/form.services';
import { HTTPService } from 'src/app/services/http.service';
import { ThemeService } from 'src/app/services/theme.service';
import { UploadServices } from 'src/app/services/upload.services';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';

@Component({
    selector: 'app-form-view-image',
    templateUrl: './form-view-image.component.html',
    styleUrls: ['./form-view-image.component.css'],
    providers: [],
    standalone: false
})
export class FormViewImageComponent implements OnInit {

  config: columnsDef;
  group: UntypedFormGroup;
  row: Object;
  tabindex:string;
  entityName:string;
  arrayColumnsDef:columnsDef[] = [];
  maxsize  = 2e+6;

  @ViewChild("fileInput") fileInput: ElementRef;
  files  = [];  
  layoutOption:string[] = ['dark','light'];
  image =  this.sanitizer.bypassSecurityTrustUrl( "assets/image/no-image-icon-round.png");
  hide = true;
  hideConfirmacao = true;
  sub:Subscription;
  sub2:Subscription;
  sub3:Subscription;
  condition:string="";
  
  @Output() editEvent:EventEmitter<boolean> = new EventEmitter();

  constructor( private http:HTTPService, private sanitizer: DomSanitizer,private uploadService: UploadServices,
  private spinner: NgxSpinnerService, private fs:FormServices, private cd:ChangeDetectorRef,
  public ThemeService:ThemeService) { }

  ngOnInit() {
  }

  ngAfterViewInit(){
    this.condition = this.getCondition();
    this.loadData();
  }

  ngOnDestroy(){
    if ( this.sub !=null){this.sub.unsubscribe();}
    if ( this.sub2 !=null){this.sub2.unsubscribe();}
    if ( this.sub3 !=null){this.sub3.unsubscribe();}
  }


  showPreview(event) {
    
    let file:Blob = (event.target as HTMLInputElement).files[0];
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(file);

    if (file.size > this.maxsize) {
      //this.image = ;
      throw ('Aquivo é muito grande. Tamanho máximo 2MB.');
    }

    
    fileReader.onload = ((array)=>{
      
      let TYPED_ARRAY = new Uint8Array(array.target.result as ArrayBuffer);
      //const STRING_CHAR = String.fromCharCode.apply(null, TYPED_ARRAY);

      var binary = '';
      var bytes = new Uint8Array( TYPED_ARRAY );
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
          binary += String.fromCharCode( bytes[ i ]  & 0xFF );
      }
      
      let base64String = btoa(binary);

      this.group.get(this.config.COLUMNNAME).patchValue(base64String);
      this.group.get(this.config.COLUMNNAME).updateValueAndValidity()
      
      let objectURL = 'data:image/png;base64,' + base64String;
      this.image = this.sanitizer.bypassSecurityTrustUrl(objectURL);

      this.cd.markForCheck();

    })

    
  }


  getCondition():string| null{
    let ob:Object = {};  
    
    this.arrayColumnsDef.filter(x=>{return x.ISPK === 1}).forEach(y=>{
          //ob[y.COLUMNNAME] = this.row[y.COLUMNNAME];
          ob['this.'+y.COLUMNNAME] = this.row[y.COLUMNNAME]; //jdbc
      
    });

    return ObjectUtil.transformConditionToString(ob);
  }

  loadData(){

    this.spinner.show("image-"+this.config.COLUMNNAME);
    let ob = {
        entityName: this.entityName,
        condition: this.condition,
        rows: 1,
        showImageData: true,
        showImageDataBase64: true
    }
    
    this.sub2 = this.http.post(ob,'JsonBrokerServices/find',false,true,true).subscribe(data=>{
        if (  ObjectUtil.isNotEmpty(data[this.entityName]) && 
              ObjectUtil.isNotEmpty(data[this.entityName][0]) && 
              ObjectUtil.isNotEmpty(data[this.entityName][0][this.config.COLUMNNAME] )){

            let image = data[this.entityName][0][this.config.COLUMNNAME];
            this.group.get(this.config.COLUMNNAME).patchValue(image);

            let objectURL = 'data:image/png;base64,' + image;
            this.image = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        }else{
            this.image = this.sanitizer.bypassSecurityTrustUrl("assets/image/no-image-icon-round.png")
        } 
        this.spinner.hide("image-"+this.config.COLUMNNAME);
        this.cd.markForCheck();
        
    },error=>{
        this.spinner.hide("image-"+this.config.COLUMNNAME);
        throw error;
    },()=>{

    });
}

 private upload() {  
    this.fileInput.nativeElement.value = '';  
    this.files.forEach(file => { 
      this.callUploadService(file,this.entityName,this.config.COLUMNNAME,this.condition);  
      this.editEvent.next(true);
    });  
  }

  callUploadService(file, entityName:string, columnName:string, condicao:string) {  
  
    const formData = new FormData();  
    formData.append('file', file.data, 'image');  
    
    let ob = {
        entityName: entityName,
        datafield: columnName,
        condition: condicao
    }
    
    let blob = new Blob([JSON.stringify(ob)], {
      type: 'application/json',
    });
    formData.append('data',JSON.stringify(ob));
  
    file.inProgress = true;  
    this.uploadService.progress.subscribe((value)=>{
        file.progress = value;
        this.cd.detectChanges();

        if (value == 100) {
            file.inProgress = false;
        }
    

    });
 
      
    this.uploadService.upLoadFile(formData, true).subscribe({
      complete:()=>file.progress = 0
    }); 
    
  }
  
  onClick() {  
    this.files = [];
    const fileInput = this.fileInput.nativeElement;
    fileInput.onchange = () => {  
        for (let index = 0; index < fileInput.files.length; index++)  {  
             const file = fileInput.files[index];  
                      
             if (file.size > this.maxsize) {
                return;
             }

             this.files.push({ data: file, inProgress: false, progress: 0});  
        }  
        
        this.upload();  
    };  
    fileInput.click();  
  }


  editing(){
    this.editEvent.next(true)
  }
}
